import { render, staticRenderFns } from "./MarkUnsatisfactoryIcons.vue?vue&type=template&id=40a6ec73"
import script from "./MarkUnsatisfactoryIcons.vue?vue&type=script&lang=js"
export * from "./MarkUnsatisfactoryIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports